import * as _ from "lodash";
import { AMPLITUDE_EVENTS } from "core-ui/client/src/app/core/amplitude";
import MaskUtil from "core-ui/client/src/app/MaskUtil";
import ExternalLogger from "core-ui/client/src/app/ExternalLogger";
import beneficiaryStates from "../../common/constants/beneficiaryStates";
import beneficiaryTypeCodes from "../../common/constants/beneficiaryTypeCodes";
import beneficiaryTypeDelimiter from "../../common/constants/beneficiaryTypeDelimiter";
import beneficiaryDesignationCodes from "../../common/constants/beneficiaryDesignationCodes";
import beneficiaryPageEvents from "../../common/constants/beneficiaryPageEvents";
import beneficiaryMaritalStatuses from "../../common/constants/beneficiaryMaritalStatuses";
import beneficiaryRelationshipCodes from "../../common/constants/beneficiaryRelationshipCodes";
import {
    queryFocusableElements,
    handleKeyboardDownEvent,
    keyboardInteractions
} from "core-ui/client/react/core/utils/accessibilityHelpers";

/**
 *
 * @param $scope
 * @param $state
 * @param dataService
 * @constructor
 */
var BeneficiaryController = function (
    $scope,
    groupId,
    individualId,
    $q,
    $state,
    $stateParams,
    $translate,
    beneficiaryService,
    beneficiaryTypeService,
    dataService,
    participantService,
    eventBus,
    transactionAccessFactory
) {
    var vm = this;
    var logger = ExternalLogger.getInstance("BeneficiaryController");

    $scope.inCustomEnrollment = $stateParams.inEnrollment === true;

    $scope.data = {
        hasParticipantAddressOnFile: false,
        beneficiaryAddressRequired: false,
        beneficiarySSNRequired: false,
        beneficiaryDOBRequired: false,
        qjsaVerificationRequired: false,
        showMaritalStatus: false,
        maritalStatus: null,
        beneficiary: {},
        beneficiaries: {
            Primary: [],
            uiPrimary: [],
            Contingent: [],
            uiContingent: [],
            New: [],
            Delete: []
        },
        originalBeneficiaries: [],
        dataChanged: false,
        autoAllocations: false,
        startUpcheck: true,
        hasSomeInvalidData: false,
        isBeneficiaryDataChanged: true,
        beneUAcess: false,
        beneRAccess: false,
        beneMAcess: false
    };

    $scope.data.beneficiaryStates = beneficiaryStates;
    $scope.data.beneficiaryTypeCodes = beneficiaryTypeCodes;

    $scope.errors = [];
    //$scope.hasInValiddata = false;

    initViewModel();

    $scope.trackSpousalConsentDownload = function () {
        eventBus.dispatch(beneficiaryPageEvents.EDIT_PAGE_SPOUSAL_DOC, this);
    };

    $scope.trackQJSADownload = function () {
        eventBus.dispatch(beneficiaryPageEvents.EDIT_PAGE_QJSA_DOC, this);
    };

    async function initViewModel() {
        // groupId will be passed in via ui-router from login-ui
        if (groupId) {
            dataService.setGroupId(groupId);
        }

        await $translate(["app.beneficiary.buttons.continue"]).then(function (translation) {
            vm.mainPageSubmitButtonName = translation["app.beneficiary.buttons.continue"];
        });

        var deferred = $q.defer();

        var valObj = {};
        var txnCodeParams = {
            txnCode: "WNBEN,WUBENE,WNBMSU",
            individualId: individualId,
            groupId: groupId
        };

        transactionAccessFactory.queryWithAccount(
            txnCodeParams,
            function (response) {
                if (response) {
                    valObj.gaId = groupId;
                    $scope.data.beneRAccess = response.WNBEN;
                    $scope.data.beneUAcess = response.WUBENE;
                    $scope.data.beneMAcess = response.WNBMSU;
                    beneficiaryService.setBeneAccessParams(
                        $scope.data.beneRAccess,
                        $scope.data.beneUAcess,
                        $scope.data.beneMAcess
                    );
                }
                deferred.resolve(valObj);
            },
            function (err) {
                //Error with transaction access call
                console.error("transaction authoriziation retrieval error", err);
            }
        );

        var planFormsLink =
            "/participant/accounts/#/account/" + individualId + "/" + groupId + "/plan-forms";

        //
        // Translation Strings
        vm.translate = {
            nonSpousalBeneficiaryFormLink: {
                linkBegin:
                    '<a ng-click="trackSpousalConsentDownload()" href="' + planFormsLink + '">',
                linkEnd: "</a>"
            },
            qjsaBeneficiaryFormLink: {
                linkBegin: '<a ng-click="trackQJSADownload()" href="' + planFormsLink + '">',
                linkEnd: "</a>"
            },
            continueButton: ""
        };

        dataService.beneficiaryResponse().then(function () {
            var scopeDataValues = [
                "maritalStatus",
                "maritalStatuses",
                "beneficiaryDesignations",
                "beneficiaryTypes",
                "states",
                "countries",
                "qjsaVerificationRequired",
                "participantAddressOnFile",
                "beneficiaryAddressRequired",
                "beneficiarySSNRequired",
                "beneficiaryDOBRequired",
                "hasParticipantAddressOnFile",
                "showMaritalStatus"
            ];

            var promises = [];

            angular.forEach(scopeDataValues, function (scopeDataValue) {
                var fn = "get" + scopeDataValue.charAt(0).toUpperCase() + scopeDataValue.slice(1);
                promises.push(dataService[fn]());
            });

            //
            // Populate the $scope.data object
            $q.all(promises).then(function (results) {
                angular.forEach(scopeDataValues, function (scopeDataValue, n) {
                    $scope.data[scopeDataValue] = results[n];
                });

                beneficiaryTypeService.setTypes($scope.data.beneficiaryTypes);

                participantService.setMaritalStatus($scope.data.maritalStatus);

                // Set the hierarchy of beneficiary types and relationships for the combined select list
                setTypeRelationshipHierarchy();

                //
                // Get beneficiaries
                vm.getBeneficiaries();
            });
        });
    }

    function setTypeRelationshipHierarchy() {
        beneficiaryTypeService.setTypeRelationshipHierarchyFrom($scope.data.beneficiaryTypes);
    }

    vm.getBeneficiaries = function () {
        var deferred = $q.defer();

        var promise = dataService.getBeneficiaries();

        promise.then(
            function (beneficiaries) {
                // Determine which view to display on first load
                if (beneficiaries.Primary.length > 0 || beneficiaries.Contingent.length > 0) {
                    if (!$scope.inCustomEnrollment) {
                        // Display the list view
                        $scope.navigateToList();
                    }
                } else {
                    // There are no beneficiaries on file, so we want to automatically split
                    // allocations for beneficiaries as they are added
                    $scope.data.autoAllocations = true;

                    // Display the form view
                    // Before redirecting the user to add page make sure the group has update access with the following scoped variable
                    if ($scope.data.beneUAcess != "false") {
                        vm.addBeneficiary(beneficiaryDesignationCodes.Primary);
                    } else {
                        $scope.data.errorWithUpdateAccess = true;
                    }
                }

                var beneKeys = ["Primary", "Contingent", "New"];
                angular.forEach(beneKeys, function (key) {
                    angular.forEach(beneficiaries[key], function (beneficiary) {
                        beneficiary.beneficiaryState = $scope.data.beneficiaryStates.default;

                        // Set the full name to display on the list view
                        beneficiary.name = beneficiaryService.getBeneficiaryName(beneficiary);

                        // Set a unique ID for the beneficiary
                        beneficiary.uniqueId = beneficiaryService.getUniqueId();

                        beneficiaryService.add(beneficiary);
                    });
                });

                $scope.data.beneficiaries = beneficiaries;
                $scope.data.initialMaritalStatus = $scope.data.maritalStatus;

                vm.constructUIDetails();

                $scope.data.originalBeneficiaries = JSON.parse(
                    JSON.stringify(
                        $scope.data.beneficiaries.Primary.concat(
                            $scope.data.beneficiaries.Contingent
                        )
                    )
                );

                $scope.data.startUpcheck = false;

                onLoad();

                deferred.resolve();
            },
            function (failureReason) {
                deferred.reject(failureReason);
            }
        );

        return deferred.promise;
    };

    vm.constructUIDetails = function () {
        var beneKeys = ["Primary", "Contingent"];
        var uiBene = null;
        var uiBeneError = null;
        $scope.data.beneficiaries.uiPrimary = [];
        $scope.data.beneficiaries.uiSecondary = [];
        angular.forEach(beneKeys, function (key) {
            angular.forEach($scope.data.beneficiaries[key], function (beneficiary) {
                uiBene = {
                    errored: false,
                    beneficiary: beneficiary,
                    saveErrors: null
                };
                if (beneficiary.saveErrors) {
                    uiBeneError = {
                        errored: true,
                        beneficiary: null,
                        saveErrors: beneficiary.saveErrors
                    };
                } else {
                    uiBeneError = null;
                }
                if (key === "Primary") {
                    $scope.data.beneficiaries.uiPrimary.push(uiBene);
                    if (uiBeneError) {
                        $scope.data.beneficiaries.uiPrimary.push(uiBeneError);
                    }
                } else {
                    $scope.data.beneficiaries.uiSecondary.push(uiBene);
                    if (uiBeneError) {
                        $scope.data.beneficiaries.uiSecondary.push(uiBeneError);
                    }
                }
            });
        });
    };

    function onLoad() {
        var maritalStatuses = beneficiaryMaritalStatuses;

        // Disable the Spouse option in the relationship dropdown if the beneficiary is single
        if ($scope.data.maritalStatus === maritalStatuses.Single) {
            $scope.enableSpouseRelationship(false);
        }
    }

    $scope.enableSpouseRelationship = function (enable) {
        var prefix = $scope.data.beneficiaryTypeCodes.Individual + beneficiaryTypeDelimiter;
        var relationshipCodes = beneficiaryRelationshipCodes;
        var spouseElement = document.querySelector(
            '#beneficiaryType option[value="' + prefix + relationshipCodes.Spouse + '"]'
        );

        if (enable) {
            spouseElement.removeAttribute("disabled");
        } else {
            spouseElement.setAttribute("disabled", true);
        }
    };

    $scope.enableDomesticPartnerRelationship = function (enable) {
        var prefix = $scope.data.beneficiaryTypeCodes.Individual + beneficiaryTypeDelimiter;
        var relationshipCodes = beneficiaryRelationshipCodes;

        document
            .querySelector(
                '#beneficiaryType option[value="' +
                    prefix +
                    relationshipCodes.DomesticPartner +
                    '"]'
            )
            .setAttribute("disabled", !enable);
    };

    /**
     * Add a beneficiary
     */
    vm.addBeneficiary = function (defaultDesignation) {
        // Get a new beneficiary object
        $scope.beneficiary = _.assign(
            {},
            beneficiaryService.getModel($scope.data.participantAddressOnFile)
        );

        $scope.beneficiary.beneficiaryState = $scope.data.beneficiaryStates.default;

        $scope.beneficiary.new = true;

        if (defaultDesignation) {
            $scope.beneficiary.beneficiaryDesignation = defaultDesignation;
        } else {
            if ($scope.data.beneficiaries.Primary.length === 0) {
                $scope.beneficiary.beneficiaryDesignation = beneficiaryDesignationCodes.Primary;
            }
        }

        $scope.navigateToAdd();
    };

    vm.editBeneficiary = function (beneficiary) {
        $scope.beneficiary = _.assign(
            {
                beneficiaryState: $scope.data.beneficiaryStates.default
            },
            beneficiary
        );

        if (beneficiary.id) {
            if (
                $scope.beneficiary.beneficiaryType === "TRU" ||
                $scope.beneficiary.beneficiaryType === "OTH"
            ) {
                $scope.beneficiary.socialSecurityNumber = MaskUtil.maskTIN(
                    $scope.beneficiary.socialSecurityNumber
                );
            }
            $scope.navigateToEdit(beneficiary.id);
        } else {
            $scope.navigateToAdd();
        }
    };
    vm.handleKeyboardDownEvent = function (event, beneficiary) {
        handleKeyboardDownEvent({
            event,
            keys: keyboardInteractions.button,
            output: function () {
                vm.editBeneficiary(beneficiary);
            }
        });
    };
    vm.isUpdateAllowed = function () {
        var beneAccess = beneficiaryService.getBeneAccessParams();
        return beneAccess.beneUAccess == "true";
    };

    vm.isTINRequired = function () {
        return false;
    };

    vm.checkifValidFields = function (beneficiary) {
        var method = "checkifValidFields()";
        var hasInValiddata = false;
        if (beneficiary.id) {
            if (
                ($scope.data.beneficiarySSNRequired || beneficiary.socialSecurityNumber) &&
                vm.getType(beneficiary) === "IND"
            ) {
                if (
                    !MaskUtil.isMasked(beneficiary.socialSecurityNumber) &&
                    (beneficiary.socialSecurityNumber === null ||
                        beneficiary.socialSecurityNumber.length != 9)
                ) {
                    hasInValiddata = true;
                    $scope.data.hasSomeInvalidData = true;
                    logger.debug("{0} - ssn validation issue : {1}", [
                        method,
                        beneficiary ? JSON.stringify(beneficiary) : "null"
                    ]);
                    return hasInValiddata;
                }
            }
            if (
                ($scope.data.beneficiaryDOBRequired || beneficiary.dateOfBirth) &&
                vm.getType(beneficiary) === "IND"
            ) {
                if (
                    !MaskUtil.isMasked(beneficiary.dateOfBirth) &&
                    (beneficiary.dateOfBirth === null || beneficiary.dateOfBirth.length != 8)
                ) {
                    hasInValiddata = true;
                    $scope.data.hasSomeInvalidData = true;
                    logger.debug("{0} - DOB validation issue : {1}", [
                        method,
                        beneficiary ? JSON.stringify(beneficiary) : "null"
                    ]);
                    return hasInValiddata;
                }
            }
            if ($scope.data.beneficiaryAddressRequired) {
                if (!(beneficiary.address1 && beneficiary.city)) {
                    hasInValiddata = true;
                    $scope.data.hasSomeInvalidData = true;
                    logger.debug("{0} - address validation issue : {1}", [
                        method,
                        beneficiary ? JSON.stringify(beneficiary) : "null"
                    ]);
                    return hasInValiddata;
                }

                if (!beneficiary.country.code) {
                    hasInValiddata = true;
                    $scope.data.hasSomeInvalidData = true;
                    logger.debug("{0} - country code validation issue : {1}", [
                        method,
                        beneficiary ? JSON.stringify(beneficiary) : "null"
                    ]);
                    return hasInValiddata;
                } else {
                    if (beneficiary.country.code == "US" || beneficiary.country.code == "CA") {
                        if (
                            beneficiary.state === null ||
                            !(beneficiary.state.code && beneficiary.zipCode)
                        ) {
                            hasInValiddata = true;
                            $scope.data.hasSomeInvalidData = true;
                            logger.debug("{0} - US/STATE/ZIP validation issue : {1}", [
                                method,
                                beneficiary ? JSON.stringify(beneficiary) : "null"
                            ]);
                            return hasInValiddata;
                        }
                    }
                }
            }
            if (!beneficiary.beneficiaryDesignation) {
                hasInValiddata = true;
                $scope.data.hasSomeInvalidData = true;
                logger.debug("{0} - designation validation issue (missing) : {1}", [
                    method,
                    beneficiary ? JSON.stringify(beneficiary) : "null"
                ]);
                return hasInValiddata;
            }

            if (beneficiary.beneficiaryDesignation === "P" && vm.getMaritalStatus() === null) {
                hasInValiddata = true;
                $scope.data.hasSomeInvalidData = true;
                logger.debug("{0} - designation/status validation issue : {1}", [
                    method,
                    beneficiary ? JSON.stringify(beneficiary) : "null"
                ]);
                return hasInValiddata;
            }
            if (
                vm.getTypeOrRelationshipDisplay(beneficiary.beneficiaryType) === "Invalid details"
            ) {
                hasInValiddata = true;
                $scope.data.hasSomeInvalidData = true;
                logger.debug("{0} - 'invalid details' validation issue : {1}", [
                    method,
                    beneficiary ? JSON.stringify(beneficiary) : "null"
                ]);
                return hasInValiddata;
            }
            if (vm.getType(beneficiary) === "IND") {
                if (!(beneficiary.beneficiaryFirstName && beneficiary.beneficiaryLastName)) {
                    hasInValiddata = true;
                    $scope.data.hasSomeInvalidData = true;
                    logger.debug("{0} - IND firstname/lastname validation issue : {1}", [
                        method,
                        beneficiary ? JSON.stringify(beneficiary) : "null"
                    ]);
                    return hasInValiddata;
                }
            }

            //non individual i.e trust etc require last name to be filled
            if (vm.getType(beneficiary) !== "IND") {
                if (!beneficiary.beneficiaryLastName) {
                    hasInValiddata = true;
                    $scope.data.hasSomeInvalidData = true;
                    logger.debug("{0} - !IND lastname validation issue : {1}", [
                        method,
                        beneficiary ? JSON.stringify(beneficiary) : "null"
                    ]);
                    return hasInValiddata;
                }
            }
            // trust require date of trust and tax identification number
            if (vm.getType(beneficiary) === $scope.data.beneficiaryTypeCodes.Trust) {
                //check for date of trust exists
                if (
                    beneficiary.dateOfBirth === null ||
                    beneficiary.dateOfBirth.replace("/", "").replace("/", "").length != 8
                ) {
                    hasInValiddata = true;
                    $scope.data.hasSomeInvalidData = true;
                    return hasInValiddata;
                }
                //check if Tax Identification Number exists
                if (vm.isTINRequired()) {
                    // check if tax identification number exists
                    if (
                        beneficiary.socialSecurityNumber === null ||
                        beneficiary.socialSecurityNumber.replace("-", "").length != 9
                    ) {
                        hasInValiddata = true;
                        $scope.data.hasSomeInvalidData = true;
                        return hasInValiddata;
                    }
                }
            }

            if (vm.getType(beneficiary) === $scope.data.beneficiaryTypeCodes.Other) {
                //check if Tax Identification Number exists
                if (vm.isTINRequired()) {
                    if (
                        !MaskUtil.isMasked(beneficiary.dateOfBirth) &&
                        (beneficiary.socialSecurityNumber === null ||
                            beneficiary.socialSecurityNumber.length != 9)
                    ) {
                        hasInValiddata = true;
                        $scope.data.hasSomeInvalidData = true;
                        return hasInValiddata;
                    }
                }
            }
        }

        return hasInValiddata;
    };

    vm.getBeneficiariesLength = function (beneficiaries) {
        var count = 0;
        for (var i = 0; i < beneficiaries.length; i++) {
            var bene = beneficiaries[i];
            if (!bene.errored) {
                count = count + 1;
            }
        }
        return count;
    };

    $scope.checkifValidFields = function (beneficiary) {
        return vm.checkifValidFields(beneficiary);
    };

    $scope.constructUIDetails = function () {
        return vm.constructUIDetails();
    };

    //
    // Service accessor functions
    // ======================================================================
    vm.getType = function (beneficiary) {
        return beneficiaryService.getType(beneficiary);
    };

    vm.getRelationship = function (beneficiary) {
        return beneficiaryService.getRelationship(beneficiary);
    };

    vm.getTypeOrRelationshipDisplay = function (beneficiaryType) {
        return beneficiaryService.getTypeOrRelationshipDisplay(
            beneficiaryType,
            beneficiaryTypeService.getTypes()
        );
    };

    vm.getMaritalStatus = function () {
        return participantService.getMaritalStatus();
    };

    //
    // Routing functions
    // ======================================================================

    $scope.navigateToConfirmation = function () {
        eventBus.dispatch(beneficiaryPageEvents.LANDING_PAGE_SAVE, this);
        eventBus.dispatchAmplitude({
            event_type: AMPLITUDE_EVENTS.SELECT_BUTTON,
            event_properties: {
                selection: beneficiaryPageEvents.LANDING_PAGE_SAVE
            }
        });
        $state.go("accountDetails.beneficiaries.confirmBeneficiaries");
    };

    $scope.navigateToList = function () {
        eventBus.dispatch(beneficiaryPageEvents.LANDING_PAGE_VIEW, this);
        eventBus.dispatchAmplitude({
            event_type: AMPLITUDE_EVENTS.VIEW_PAGE,
            event_properties: {
                selection: beneficiaryPageEvents.LANDING_PAGE_VIEW
            }
        });
        $state.go("accountDetails.beneficiaries.listBeneficiaries");
    };

    $scope.navigateToAdd = function () {
        eventBus.dispatch(beneficiaryPageEvents.LANDING_PAGE_ADD, this);
        eventBus.dispatchAmplitude({
            event_type: AMPLITUDE_EVENTS.SELECT_BUTTON,
            event_properties: {
                selection: beneficiaryPageEvents.LANDING_PAGE_ADD
            }
        });
        $state.go("accountDetails.beneficiaries.addBeneficiary");
    };

    $scope.navigateToEdit = function (beneficiaryId) {
        var beneAccess = beneficiaryService.getBeneAccessParams();
        if (beneAccess.beneUAccess == "false") {
            eventBus.dispatch(beneficiaryPageEvents.LANDING_PAGE_VIEW, this);
            eventBus.dispatchAmplitude({
                event_type: AMPLITUDE_EVENTS.VIEW_PAGE,
                event_properties: {
                    selection: beneficiaryPageEvents.LANDING_PAGE_VIEW
                }
            });
            $state.go("accountDetails.beneficiaries.viewOnlyBeneficiaries", {
                beneficiaryId: beneficiaryId
            });
        } else {
            eventBus.dispatch(beneficiaryPageEvents.LANDING_PAGE_EDIT, this);
            eventBus.dispatchAmplitude({
                event_type: AMPLITUDE_EVENTS.SELECT_FIELD,
                event_properties: {
                    selection: beneficiaryPageEvents.LANDING_PAGE_EDIT
                }
            });
            $state.go("accountDetails.beneficiaries.editBeneficiary", {
                beneficiaryId: beneficiaryId
            });
        }
    };
};
BeneficiaryController.$inject = [
    "$scope",
    "groupId",
    "individualId",
    "$q",
    "$state",
    "$stateParams",
    "$translate",
    "beneficiaryService",
    "beneficiaryTypeService",
    "dataService",
    "participantService",
    "eventBus",
    "transactionAccessFactory"
];

export default BeneficiaryController;
